module.exports = __webpack_public_path__ + "img/safari-6b0c999477be004264f0524eb0596141.svg";